jQuery(document).ready(function($) {
    $('.project-archive__wrapper').each(function(){
        $(this).find('.recent-projects__card-title').matchHeight();      
    });
    $('.recent-projects__card-wrapper').each(function(){
        $(this).find('.recent-projects__card-title').matchHeight();      
    }); 
    
    $('.news__card-wrapper').each(function(){
        $(this).find('.news__card-title').matchHeight();      
    }); 

    $('.news-archive__wrapper').each(function(){
        $(this).find('.news__card-title').matchHeight();      
    }); 
   
    $('.two-boxes-link').each(function(){
        $(this).find('.two-boxes-link__title').matchHeight();      
    });

    $('.catalogues__item-wrapper').each(function(){
        $(this).find('.catalogues__image-wrapper').matchHeight();      
    });

    $('.child-category-card').each(function(){
        $(this).find('.category-card__title').matchHeight();      
    });

});

(function($) {
    var waitForFinalEvent = (function () {
      var timers = {};
      return function (callback, ms, uniqueId) {
        if (!uniqueId) {
          uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
          clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
      };
    })();

    var sameHeight = {
        init: function(){
            $('.project-archive__wrapper').each(function(){
                $(this).find('.recent-projects__card-title').matchHeight();      
            });
            $('.recent-projects__card-wrapper').each(function(){
                $(this).find('.recent-projects__card-title').matchHeight();      
            }); 
            
            $('.news__card-wrapper').each(function(){
                $(this).find('.news__card-title').matchHeight();      
            }); 
        
            $('.news-archive__wrapper').each(function(){
                $(this).find('.news__card-title').matchHeight();      
            }); 
           
            $('.two-boxes-link').each(function(){
                $(this).find('.two-boxes-link__title').matchHeight();      
            });
        
            $('.catalogues__item-wrapper').each(function(){
                $(this).find('.catalogues__image-wrapper').matchHeight();      
            });
        
            $('.child-category-card').each(function(){
                $(this).find('.category-card__title').matchHeight();      
            });
        }
    };
  
    var Boot = {
      loaded: false,
      start: function () {
        sameHeight.init();
      },
      resized: function () {
        sameHeight.init();
      },
    };
  
    $(document).ready(function () {
      Boot.start();
    });
    $(window).on("resize orientationchange", function () {
      waitForFinalEvent(function () {
        Boot.resized();
      }, 500);
    });
  })(jQuery);
  